import React from 'react';

function Content({ width = 'full', children, className }) {
  return (
    <div className={`content content--${width}-width ${className}`}>
      {children}
    </div>
  );
}

export default Content;
